const removeHTMLElement = (elem: HTMLElement) => {
  return elem.remove();
}

const createMessage = (success: boolean) => {
  if(success) {
    return `
      <div class="client-message">
        <p>Copied successfully to clipboard</p>
      <div>
    `;
  } else {
    return `
      <div class="client-message">
        <p>An error has occurred. Please try again later</p>
      <div>
    `;
  }
}

export const initCopyTextContents = () => {
  const copyELems: NodeListOf<HTMLElement> = document.querySelectorAll('[data-copy]');

  copyELems.forEach((elem) => {
    const copyTarget = elem.querySelector('[data-copy-target]');
    const copyBtn = elem.querySelector('[data-copy-button]');

    async function copyText(textToCopy: string) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        let clientMessage = createMessage(true);
        elem.insertAdjacentHTML("beforeend", clientMessage);

        setTimeout(() => {
          removeHTMLElement(elem.querySelector('.client-message'));
        }, 2000);
      } catch (err) {
        let clientMessage = createMessage(false);
        elem.insertAdjacentHTML("beforeend", clientMessage);

        setTimeout(() => {
          removeHTMLElement(elem.querySelector('.client-message'));
        }, 3000);
        console.error('Failed to copy: ', err);
      }
    }

    copyBtn.addEventListener('click', () => {
      copyText(copyTarget.textContent);
      copyBtn.setAttribute('disabled', 'true');

      setTimeout(() => {
        copyBtn.removeAttribute('disabled');
      },2000)
    });
  });
}